import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, unref as _unref, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-new.svg'
import _imports_1 from '@/assets/foot-grid.png'


const _withScopeId = n => (_pushScopeId("data-v-4de05650"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-primary-2\" data-v-4de05650><div class=\"container mx-auto divide-y lg:divide-x lg:divide-y-0 divide-white flex flex-wrap text-white\" data-v-4de05650><div class=\"group-stat lg:justify-center\" data-v-4de05650><div class=\"group-stat__title text-16px lg-text-20px\" data-v-4de05650> Total CO2 Sequestered (kg) </div><div class=\"group-stat__value text-34px lg-text-42px\" id=\"totalCO2\" data-v-4de05650></div></div><div class=\"group-stat\" data-v-4de05650><div class=\"group-stat__title text-16px lg-text-20px\" data-v-4de05650> Trees Planted </div><div class=\"group-stat__value text-34px lg-text-42px\" id=\"treesPlanted\" data-v-4de05650></div></div><div class=\"group-stat\" data-v-4de05650><div class=\"group-stat__title text-16px lg-text-20px\" data-v-4de05650>Wildlife</div><div class=\"group-stat__value text-34px lg-text-42px\" id=\"wildlife\" data-v-4de05650></div></div><div class=\"group-stat\" data-v-4de05650><div class=\"group-stat__title text-16px lg-text-20px\" data-v-4de05650>Donors</div><div class=\"group-stat__value text-34px lg-text-42px\" id=\"donors\" data-v-4de05650></div></div></div></div>", 1)
const _hoisted_3 = { class: "bg-gray-50" }
const _hoisted_4 = { class: "container mx-auto py-6 px-8" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"container mx-auto flex flex-wrap py-8\" data-v-4de05650><div class=\"w-full lg:flex-1 py-8 lg:py-12 px-4\" data-v-4de05650><div class=\"font-semibold leading-none pb-4 text-48px lg-text-72px text-center lg:text-left\" data-aos=\"fade-up\" data-v-4de05650> Plant your<br data-v-4de05650>forest with </div><div class=\"flex justify-center lg:justify-start\" data-aos=\"fade-up\" data-v-4de05650><div class=\"bg-primary-2 text-white w-auto text-32px lg-text-48px font-semibold px-2 py-2 inline-block\" data-v-4de05650><img class=\"h-10\" src=\"" + _imports_0 + "\" data-v-4de05650></div></div></div><div class=\"w-full lg:flex-1 py-8 lg:py-16 text-center lg:text-left px-4\" data-v-4de05650><div class=\"text-primary-dark mb-6 text-28px\" data-aos=\"fade-up\" data-v-4de05650><div class=\"font-extrabold\" data-v-4de05650>Our Mission</div></div><div class=\"text-18px lg-text-24px pr-6 font-medium\" data-aos=\"fade-up\" data-v-4de05650> Bring Back the Forest is a non-profit enterprise whose goal is to bring back the forest to save the Earth from global warming. Our mission is to grow a sustainable forest that will last forever. </div></div></div><div class=\"container mx-auto py-16 lg:py-56 px-4\" data-v-4de05650><div class=\"mb-6 font-bold text-center text-36px lg-text-56px\" data-aos=\"fade-in\" data-v-4de05650> How is BBTF different? </div><div class=\"mt-6 text-center text-primary-2 text-24px lg-text-48px font-bold\" data-aos=\"fade-in\" style=\"font-family:sarabun;\" data-v-4de05650> “BBTF&#39;s goal is to raise forests that will last for<br data-v-4de05650> millennia.” </div></div><div class=\"bg-primary-2 px-4\" data-v-4de05650><div class=\"container mx-auto py-24\" data-aos=\"fade-in\" data-v-4de05650><div class=\"my-6 font-bold text-48px lg-text-72px text-center text-white\" style=\"font-family:sarabun;\" data-v-4de05650> How do we ensure forest<br data-v-4de05650>sustainability &amp; longevity? </div></div></div>", 3)
const _hoisted_8 = { class: "w-full max-w-5xl mx-auto pt-16 lg:pt-28 px-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-48px lg-text-56px font-semibold pt-2 pb-4",
  style: {"font-family":"sarabun"}
}, " Forest Sustainability & Longevity ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full text-18px lg-text-20px my-4" }, " To ensure that our forests will live for millennia to come, BBTF prioritizes the safety and wellbeing of each forest floral and fauna that contributes to the wellbeing of the forest as a whole. With constant monitoring and professional safety protocols, we can ensure you that our forests are secure and safe from wildfire and poaching. At BBTF, we can guarantee you a 100% tree survival rate! ", -1))
const _hoisted_11 = { class: "flex flex-wrap items-stretch my-6" }
const _hoisted_12 = { class: "px-4 py-1 flex flex-col justify-between bg-gray-100 rounded-lg h-full" }
const _hoisted_13 = { class: "text-32px font-extrabold mt-2 mb-8" }
const _hoisted_14 = { class: "flex justify-center items-center h-56 my-2 hover-zoom" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"container mx-auto pt-8 pb-5 lg:py-32 px-6\" data-v-4de05650><div class=\"text-36px lg-text-56px font-bold my-4\" style=\"font-family:sarabun;\" data-v-4de05650> Efficient CO2 Sequestration Guaranteed </div><div class=\"w-full text-24px lg-text-36px font-semibold my-4\" style=\"color:#064c29;\" data-v-4de05650> Forest Transparency </div><div class=\"mt-16 mb-0 md:mb-16\" data-v-4de05650><div class=\"flex flex-wrap lg:px-4 flex-col-reverse lg:flex-row\" data-v-4de05650><div class=\"w-full lg:w-1/2 my-2 rounded-lg py-1\" data-aos=\"fade-right\" data-v-4de05650><div data-v-4de05650><div class=\"text-24px font-semibold my-2\" data-v-4de05650> Annual measurement of CO2 sequestration, ecosystem and biodiversity contribution </div></div><div class=\"text-md my-2 text-gray-500\" data-v-4de05650> At BBTF, we prioritize transparency as one of our core values. To accurately assess the growth and wellbeing of our forests, BBTF applies the latest Blockchain technology to ensure transparency in our annual report. Unabridged data regarding the measurement, including the amount of CO2 sequestration, our forest ecosystem and biodiversity contribution, will be sent directly to our donors. </div></div><div class=\"w-full lg:w-1/2 px-8 overflow-x-hidden\" data-v-4de05650><img src=\"/images/co2.png\" alt=\"\" class=\"mx-auto w-full max-w-md px-4 my-4\" data-aos=\"fade-left\" data-v-4de05650></div></div><div class=\"flex flex-wrap\" data-v-4de05650><div class=\"w-full lg:w-1/2 px-16\" data-aos=\"fade-right\" data-v-4de05650><img src=\"/images/contribution.png\" alt=\"\" class=\"mx-auto w-full max-w-md px-4 mt-8 mb-2\" data-v-4de05650></div><div class=\"w-full lg:w-1/2 mt-1 md:mt-16 mb-8 rounded-lg py-1 overflow-x-hidden\" data-v-4de05650><div class=\"\" data-aos=\"fade-left\" data-v-4de05650><div class=\"text-24px font-semibold my-2\" data-v-4de05650> Blockchain application for accurate data reading </div><div class=\"text-md my-2 text-gray-500\" data-v-4de05650> With Blockchain, BBTF is able to keep consistent tracking of our forests&#39; data, which will be fully displayed to our donors on an annual basis. To let the donors visualize in detail how their donations have contributed to saving our planet, NFT and information tokens will be used to relay the detailed information to the donors. </div></div></div></div></div></div>", 1)
const _hoisted_17 = { class: "container mx-auto py-2 md:py-8 px-6" }
const _hoisted_18 = { class: "flex flex-wrap" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full lg:w-1/3 px-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-3xl lg:text-4xl font-semibold my-2" }, [
    /*#__PURE__*/_createTextVNode(" More than just a"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" forest–at BBTF, we "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("assure you a quality"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" planting with: ")
  ])
], -1))
const _hoisted_20 = { class: "w-full lg:w-1/3 px-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/check.png",
  class: "w-6",
  alt: "",
  "data-aos": "flip-up"
}, null, -1))
const _hoisted_22 = { class: "text-20px" }
const _hoisted_23 = { class: "w-full lg:w-1/3 px-2 -mt-4 md:mt-0" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/check.png",
  class: "w-6",
  alt: "",
  "data-aos": "flip-up"
}, null, -1))
const _hoisted_25 = { class: "text-20px" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-8 mb-12 lg:mb-24" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/forests.png",
    class: "w-full object-center",
    alt: "",
    style: {"max-height":"400px"}
  })
], -1))
const _hoisted_27 = { class: "relative py-4 lg:py-22" }
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<div class=\"relative\" data-v-4de05650><div class=\"absolute left-0 top-0 transform -translate-y-1/4 hidden lg:hidden\" data-v-4de05650><img src=\"/images/trees-left.png\" class=\"w-72\" alt=\"\" data-v-4de05650></div><div class=\"absolute right-0 top-0 transform -translate-y-1/2\" data-v-4de05650><img src=\"/images/trees-right-1.png\" class=\"w-32 lg:w-64\" alt=\"\" data-v-4de05650></div><div class=\"absolute right-0 top-10 transform -translate-y-1/4\" data-v-4de05650><img src=\"/images/trees-right-2.png\" class=\"w-32 lg:w-64\" alt=\"\" data-v-4de05650></div><div class=\"text-36px lg-text-72px font-bold my-4 px-8 text-left mr-16 lg:mr-0 lg:text-center\" data-v-4de05650> Forest: The Lung of Our Planet </div><div class=\"max-w-4xl w-full mx-auto text-18px lg-text-24px my-4 px-4 text-left lg:text-center font-medium\" data-v-4de05650> Every year, our world loses 15.3 billion trees to deforestation. Forests are the lungs of our planet: they purify the air we breathe in and help absorb carbon dioxide that is the root cause of global warming. And now the lungs of our planet are being destroyed at a faster rate than it could recover. </div></div>", 1)
const _hoisted_29 = { class: "overflow-hidden flex justify-center" }
const _hoisted_30 = { class: "max-w-6xl w-full mx-auto px-4 py-4 lg:py-22 font-medium" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-48px lg-text-64px font-bold my-8 text-center" }, " What will happen if we don't act now ", -1))
const _hoisted_32 = { class: "flex items-stretch flex-wrap" }
const _hoisted_33 = { class: "w-full lg:w-1/2 p-2" }
const _hoisted_34 = {
  class: "h-full rounded-xl px-4 py-2",
  style: {"background":"#fbc279"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-40px lg-text-56px font-bold" }, " If the Temperature Increases by 1.5°C ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-18px lg-text-24px my-4" }, "So what?", -1))
const _hoisted_37 = { class: "flex" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full lg:w-1/2 pt-8 pb-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/landing/faqs/blog/22",
    class: "btn-more lg:w-auto hoverable text-16px"
  }, "READ MORE")
], -1))
const _hoisted_39 = { class: "w-1/2 hidden lg:block hover-zoom" }
const _hoisted_40 = { class: "w-full lg:w-1/2 p-2" }
const _hoisted_41 = {
  class: "h-full rounded-xl px-4 py-2",
  style: {"background":"#dec28c"}
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-40px lg-text-56px font-bold" }, " In the next 5 years... ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-18px lg-text-24px my-4" }, " Our world is running out of time. What will happen in the next five years if we don't act now? ", -1))
const _hoisted_44 = { class: "flex" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full lg:w-1/2 pt-8 pb-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/landing/faqs/blog/22",
    class: "btn-more lg:w-auto hoverable text-16px"
  }, "READ MORE")
], -1))
const _hoisted_46 = { class: "w-1/2 hidden lg:block hover-zoom" }
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full p-2\" data-v-4de05650><div class=\"rounded-xl px-4 py-2 flex flex-wrap\" style=\"background:#baa899;\" data-v-4de05650><div class=\"w-full lg:w-1/2 text-40px lg-text-56px font-bold\" data-v-4de05650> Save the Earth </div><div class=\"w-full lg:w-1/2 pl-6\" data-v-4de05650><div class=\"text-18px lg-text-24px my-4 x\" data-v-4de05650> What are the cause and effect of global warming? Why should we act on climate change? </div><div class=\"my-4 pt-8 pb-4\" data-v-4de05650><a href=\"/landing/faqs/blog/22\" class=\"btn-more lg:w-auto hoverable text-16px\" data-v-4de05650>READ MORE</a></div></div></div></div>", 1)
const _hoisted_48 = {
  class: "container mx-auto px-4",
  style: {"margin-bottom":"45px"}
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-48px lg-text-72px text-center my-10" }, [
  /*#__PURE__*/_createTextVNode(" Plant your trees with us now. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" For our world. And your future. ")
], -1))
const _hoisted_50 = { class: "flex justify-center my-10" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" DONATE NOW ")
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overflow-hidden flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "max-w-none",
    style: {"width":"1024px"},
    src: _imports_1
  })
], -1))
const _hoisted_53 = {
  class: "mt-16",
  style: {"background-color":"#d8f2df","margin-top":"120px","margin-bottom":"120px"}
}
const _hoisted_54 = { class: "container mx-auto px-4 pb-12 pt-20" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { "data-aos": "fade-up" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/world.svg",
    class: "mx-auto",
    style: {"width":"400px"},
    alt: ""
  })
], -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-primary-2 font-bold my-8 px-6 text-56px lg-text-72px" }, " Gracious Donors ", -1))
const _hoisted_57 = { class: "w-auto mx-auto flex my-8" }
const _hoisted_58 = { class: "w-auto mx-auto flex justify-center px-1 py-1 bg-white rounded-full overflow-hidden" }
const _hoisted_59 = { class: "lg:max-w-2xl mx-auto" }
const _hoisted_60 = ["src"]
const _hoisted_61 = { class: "flex-1 truncate" }
const _hoisted_62 = { class: "text-16px lg-text-24px truncate" }
const _hoisted_63 = { class: "text-gray-500 text-xs lg:text-sm truncate" }
const _hoisted_64 = { class: "w-24 lg:w-auto flex justify-end" }
const _hoisted_65 = { class: "bg-primary-2 rounded-full px-4 py-2 font-semibold text-white text-12px lg-text-28px truncate" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))
const _hoisted_67 = { class: "my-8 flex justify-center" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" See More ")
const _hoisted_69 = {
  class: "container mx-auto px-4 py-10",
  style: {"margin-bottom":"133px"}
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center font-semibold mb-6 text-24px" }, " Follow us for more updates :) ", -1))
const _hoisted_71 = { class: "flex lg:space-x-10 space-x-4 justify-center items-center" }
const _hoisted_72 = {
  target: "_blank",
  href: "https://web.facebook.com/Bringbacktheforest?_rdc=1&_rdr"
}
const _hoisted_73 = {
  target: "_blank",
  href: "https://twitter.com/bbtfbbtf?s=21"
}
const _hoisted_74 = {
  target: "_blank",
  href: "https://www.youtube.com/channel/UCgexR3KciJ3ZWsBOqV28HQA"
}
const _hoisted_75 = {
  target: "_blank",
  href: "https://www.instagram.com/bringbacktheforestbbtf/?igshid=YmMyMTA2M2Y%3D"
}
const _hoisted_76 = {
  target: "_blank",
  href: "https://www.tiktok.com/@bringbacktheforest"
}

import { Carousel } from 'vue3-carousel';
import LandingHero from '@/components/Landing/LandingHero.vue';
import ProgressBar from '@/components/ProgressBar.vue';

import { numberWithCommas } from '@/composables/format';

import gsap from 'gsap';
import { watch, computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import 'vue3-carousel/dist/carousel.css';
import IconWorldWarm from '@/components/Icons/IconWorldWarm.vue';
import IconWorldIce from '@/components/Icons/IconWorldIce.vue';
import IconTreesLine from '@/components/Icons/IconTreesLine.vue';

import IconFacebook from '@/components/Icons/IconFacebook.vue';
import IconTwitter from '@/components/Icons/IconTwitter.vue';
import IconYouTube from '@/components/Icons/IconYouTube.vue';
import IconTiktok from '@/components/Icons/IconTiktok.vue';
import IconIg from '@/components/Icons/IconIg.vue';
import { STRIPE_PUBLIC_KEY } from '../constants';
import useMoralis from '@/composables/useMoralis';
import { GetDonor } from '@/types/MoralisCloud';
import useToastMessage from '@/composables/useToastMessage';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const moralis = useMoralis();

const sl = ref([
  {
    title: '24/7 forest monitoring',
    img: '/images/s&l/s&l-1.png',
  },
  {
    title: 'Fast Response team ',
    img: '/images/s&l/s&l-2.png',
  },
  {
    title: 'Professional wildfire prevention protocols',
    img: '/images/s&l/s&l-3.png',
  },
  {
    title: 'Trees and animals protected from poachers',
    img: '/images/s&l/s&l-4.png',
  },
  {
    title: '100% trees survival rate target guaranteed',
    img: '/images/s&l/s&l-5.png',
  },
  {
    title: 'Planted by experts',
    img: '/images/s&l/s&l-6.png',
  },
]);

const bbtf1 = ref([
  'Longevity: our trees are planted on legally purchased land',
  'Transparency: annual report measured by security team',
  'Accountability: provide a prompt response within 1 hour',
  'Continuous Improvement',
]);
const bbtf2 = ref([
  'Sustainability: 24/7 forest monitoring, 365 days per year',
  'Measurability',
  'Efficiency: planned and planted by experts with over 30 years of forest planting experience',
]);

const news_page = ref(1);
const news_slide = ref<typeof Carousel>();
const route = useRoute();
const router = useRouter();
const toast = useToastMessage();

const paymentIntent = computed(() => route.query);

const isGDMostRecent = ref(true);
const gds = ref();
const fetchGD = async () => {
  const result = await moralis.currect.Cloud.run<GetDonor>('getDonors', {
    email: undefined,
    reverse: 'true',
    sort: isGDMostRecent.value ? 'blockTimestamp' : 'nftAmount',
    size: 10,
  });
  console.log(result);
  gds.value = result.entities;
};

const getDateTime = (date: string) => {
  const d = new Date(date);
  const mL = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  return `${d.getDate()} ${
    mL[d.getMonth()]
  } ${d.getFullYear()}, ${d.getHours()}:${d.getMinutes()} ${
    d.getHours() >= 12 ? 'PM' : 'AM'
  }`;
};

watch(news_page, (val) => {
  news_slide.value?.slideTo(val);
});
watch(isGDMostRecent, () => {
  fetchGD();
});

onMounted(async () => {
  const wait = setInterval(async (): Promise<void> => {
    if (route.path) {
      clearInterval(wait);
      if (paymentIntent.value.payment_intent_client_secret) {
        const stripe = (window as any).Stripe(STRIPE_PUBLIC_KEY);

        if (stripe) {
          const res = await stripe.retrievePaymentIntent(
            paymentIntent.value.payment_intent_client_secret
          );
          if (res.paymentIntent.status === 'succeeded') {
            router.push(`/donate/success/${res.paymentIntent.id}`);
          } else {
            if (res.paymentIntent.last_payment_error) {
              toast.error(res.paymentIntent.last_payment_error);
              clearInterval(wait);
            }
          }
        }
      }
    }
  }, 500);

  news_slide.value?.slideTo(1);
  fetchGD();

  const setCounter = (dur: number, id: string, val: number) => {
    const el = document.getElementById(id) as HTMLElement;
    const value = { val: val };
    if (el)
      gsap.from(value, {
        duration: dur,
        ease: 'circ.out',
        val: 0,
        roundProps: 'val',
        onUpdate: function () {
          el.innerText = numberWithCommas(value.val);
        },
      });
  };

  let isCounter = true;
  const checkScroll = () => {
    const el = document.getElementById('totalCO2');
    const rect = el?.getBoundingClientRect();
    if (
      isCounter &&
      window.scrollY + document.body.offsetHeight + 30 > (rect?.top || 0)
    ) {
      setCounter(8, 'totalCO2', 5);
      setCounter(8, 'treesPlanted', 50000);
      setCounter(8, 'wildlife', 5000);
      setCounter(8, 'donors', 5000);
      isCounter = false;
    }
  };
  checkScroll();
  window.addEventListener('scroll', () => {
    checkScroll();
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LandingHero),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ProgressBar, { goal: "yearly" })
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sl.value, (s, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "w-full p-2 lg:w-1/2",
            key: `s&l-${i}`
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(s.title), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("img", {
                  src: s.img,
                  alt: "",
                  class: "h-full"
                }, null, 8, _hoisted_15)
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _hoisted_16,
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bbtf1.value, (b, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `bbtf1-${i}`,
              class: "my-4 flex items-center space-x-4 bg-gray-100 rounded-2xl px-4 py-3"
            }, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, _toDisplayString(b), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bbtf2.value, (b, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `bbtf2-${i}`,
              class: "my-4 flex items-center space-x-4 bg-gray-100 rounded-2xl px-4 py-3"
            }, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, _toDisplayString(b), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _hoisted_26,
    _createElementVNode("div", _hoisted_27, [
      _hoisted_28,
      _createElementVNode("div", _hoisted_29, [
        _createVNode(IconTreesLine, {
          class: "max-w-none object-cover",
          style: {"width":"1024px: height: 30px"}
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("div", _hoisted_39, [
                _createVNode(IconWorldWarm)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _hoisted_43,
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _createVNode(IconWorldIce, { class: "" })
              ])
            ])
          ])
        ]),
        _hoisted_47
      ])
    ]),
    _createElementVNode("div", _hoisted_48, [
      _hoisted_49,
      _createElementVNode("div", _hoisted_50, [
        _createVNode(_component_router_link, {
          class: "text-white px-12 py-4 bg-primary rounded-full hoverable text-18px",
          to: "/donate"
        }, {
          default: _withCtx(() => [
            _hoisted_51
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_52,
    _createElementVNode("div", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _hoisted_55,
        _hoisted_56,
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", {
              class: _normalizeClass(["taeb-switch text-center", { left: isGDMostRecent.value, right: !isGDMostRecent.value }])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["taeb", {
                  'text-white active': isGDMostRecent.value,
                  'text-primary-2': !isGDMostRecent.value,
                }]),
                "taeb-direction": "left",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (isGDMostRecent.value = true))
              }, " Most Recent ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["taeb", {
                  'text-white active': !isGDMostRecent.value,
                  'text-primary-2': isGDMostRecent.value,
                }]),
                "taeb-direction": "right",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isGDMostRecent.value = false))
              }, " Most Forest ", 2)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gds.value, (gd, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "my-4 px-2 py-2 rounded-3xl lg:rounded-full bg-white flex space-x-2 lg:space-x-4 items-center",
              key: `gd-${i}`,
              style: {"width":"100%"}
            }, [
              _createElementVNode("img", {
                src: 
                gd.nftAmount <= 50
                  ? '/images/gd/gd-feed.svg'
                  : gd.nftAmount <= 100
                  ? '/images/gd/gd-reaf.svg'
                  : gd.nftAmount <= 1000
                  ? '/images/gd/gd-flower.svg'
                  : gd.nftAmount <= 10000
                  ? '/images/gd/gd-seedling.svg'
                  : gd.nftAmount <= 50000
                  ? '/images/gd/gd-tree.svg'
                  : gd.nftAmount <= 100000
                  ? '/images/gd/gd-forest.svg'
                  : '/images/gd/gd-world.svg'
              ,
                class: "w-12 h-12 p-2 bg-primary-2 rounded-full",
                alt: ""
              }, null, 8, _hoisted_60),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, _toDisplayString(gd.email), 1),
                _createElementVNode("div", _hoisted_63, _toDisplayString(getDateTime(gd.createdAt)), 1)
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createTextVNode(_toDisplayString(_unref(numberWithCommas)(gd.nftAmount)) + " ft", 1),
                  _hoisted_66
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_67, [
          _createVNode(_component_router_link, {
            class: "text-white px-9 py-3 bg-primary-2 rounded-md hoverable text-16px",
            to: "/landing/gracious-donors"
          }, {
            default: _withCtx(() => [
              _hoisted_68
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_69, [
      _hoisted_70,
      _createElementVNode("div", _hoisted_71, [
        _createElementVNode("a", _hoisted_72, [
          _createVNode(IconFacebook)
        ]),
        _createElementVNode("a", _hoisted_73, [
          _createVNode(IconTwitter)
        ]),
        _createElementVNode("a", _hoisted_74, [
          _createVNode(IconYouTube)
        ]),
        _createElementVNode("a", _hoisted_75, [
          _createVNode(IconIg)
        ]),
        _createElementVNode("a", _hoisted_76, [
          _createVNode(IconTiktok)
        ])
      ])
    ])
  ]))
}
}

})